import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import axios from "axios";
import {
  Badge,
  Row,
  Col,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button,
} from "reactstrap";
import { spanish } from "../../constants/spanish";
import { English } from "../../constants/english";
import * as vars from "../../constants/constants";
import { messages } from "../../constants/messages";
import { movies } from "../../constants/movies";
import { esmobiotv } from "../../constants/esmobiotv";
import { show, hide } from "../../actions/ActivityIndicatorActions";
import { getVideoOrChannelRelatedData } from "../../actions/PlayActions";
import {
  addFavoriteChannel,
  addFavoriteVideo,
} from "../../actions/FavoriteActions";
import { showMessage } from "../../actions/FlashMessageActions";
import { setHeaderTitle } from "../../actions/HeaderActions";
import { console_log, bidiotvMoviesListByLang } from "../../utils/helper";
import classnames from "classnames";
import { config } from "../../constants/domainConfig";
import { FormattedMessage } from "react-intl";

// const msg = messages[config.lang];
class Favorites extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: "1",
    };

    this.goToPlay = this.goToPlay.bind(this);
    this.channelFavorite = this.channelFavorite.bind(this);
    this.isChannelFavorite = this.isChannelFavorite.bind(this);
    this.videoFavorite = this.videoFavorite.bind(this);
    this.isVideoFavorite = this.isVideoFavorite.bind(this);
  }

  componentDidMount() {
    this.props.show();
    setTimeout(() => {
      this.props.hide();
    }, 1500);
    window.scrollTo(0, 0);
    let watchlater;
    if (config.lang == "es") {
      watchlater = "Favoritos";
    } else if (config.lang == "be") watchlater = "Favorieten";
    else if (config.lang == "it") watchlater = "Preferiti";
    else if (config.lang == "id") watchlater = "Favorit";
    else if (config.lang == "no") watchlater = "Favoritter";
    else if (config.lang == "fr") watchlater = "Préféré";
    else if (config.lang == "ee") watchlater = "Lemmikud";
    else if (config.lang == "tr") watchlater = "Favoriler";
    else if (config.lang == "lv") watchlater = "Izlase";
    else if (config.lang == "lt") watchlater = "Mėgstamiausi";
    else if (config.lang == "sr") watchlater = "Омиљено";
    else if (config.lang == "th") watchlater = "รายการโปรด";
    else if (config.lang == "el") watchlater = "Αγαπημένα";
    else if (config.lang == "de") watchlater = "Favoriten";
    else if (config.lang == "fr") watchlater = "Favoris";
    else if (config.lang == "cs") watchlater = "Oblíbené";
    else if (config.lang === "pt") watchlater = "Favoritos";
    else if (config.lang == "ar") {
      watchlater = "المفضلة";
    } else {
      watchlater = "Favorites";
    }
    this.props.setHeaderTitle(watchlater);
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  goToPlay(data, event) {
    event.preventDefault();
    if (
      event.target.tagName == "path" ||
      event.target.classList.contains("favoriteClick")
    ) {
      if (data.channel) {
        this.channelFavorite(data);
      } else {
        this.videoFavorite(data.video);
      }
    } else {
      this.props.getVideoOrChannelRelatedData(data);
      if (data.channel) {
        this.props.history.push(`/play/channel?uid=${this.props.access.uid}`);
      } else {
        this.props.history.push(
          `/play/video/?vid=${data.video.id}&uid=${this.props.access.uid}`,
        );
      }
    }
  }

  channelFavorite(data) {
    let favoriteChannels = this.props.favorite.channels;
    let indexOf = favoriteChannels.findIndex((f) => {
      return f.channelId == data.channel.channelId;
    });
    let channelToBeUpdated = {
      channelId: data.channel.channelId,
      channelName: data.channel.channelName,
      channelLang: data.channel.channelLang,
      channelImage: data.channel.channelImage,
      channelLogo: data.channel.channelLogo,
      channelGrade: data.channel.channelGrade,
      channelStatus: data.channel.channelStatus,
      channelBaseline: data.channel.channelBaseline,
      channelCategories: data.channel.channelCategories,
      isFavorite: true,
    };

    if (indexOf == -1) {
      favoriteChannels.push(channelToBeUpdated);
      axios
        .post(vars.BASE_API_URL + "/favorites/channels", channelToBeUpdated)
        .then((response) => {
          this.props.showMessage({
            message: messages[config.lang].addToFavorites,
            type: true,
          });
          console_log(response);
        })
        .catch((error) => {
          console_log(error);
        });
    } else {
      favoriteChannels.splice(indexOf, 1);
      axios
        .delete(
          vars.BASE_API_URL +
            "/favorites/channels/" +
            channelToBeUpdated.channelId,
        )
        .then((response) => {
          this.props.showMessage({
            message: messages[config.lang].removeFromFavorites,
            type: false,
          });
          console_log(response);
        })
        .catch((error) => {
          console_log(error);
        });
    }

    this.props.addFavoriteChannel(favoriteChannels);
  }

  videoFavorite(data) {
    let favoriteVideos = this.props.favorite.videos;
    let indexOf = favoriteVideos.findIndex((f) => {
      return f.videoId == data.id;
    });
    let videoToBeUpdated = {
      videoId: data.id,
      duration: data.duration,
      name: data.name,
      preview: data.preview,
    };

    if (indexOf == -1) {
      this.props.showMessage({
        message: messages[config.lang].addToFavorites,
        type: true,
      });
      favoriteVideos.push(videoToBeUpdated);
      axios
        .post(vars.BASE_API_URL + "/favorites/videos", videoToBeUpdated)
        .then((response) => {
          console_log(response);
        })
        .catch((error) => {
          console_log(error);
        });
    } else {
      this.props.showMessage({
        message: messages[config.lang].removeFromFavorites,
        type: false,
      });
      favoriteVideos.splice(indexOf, 1);
      axios
        .delete(
          vars.BASE_API_URL + "/favorites/videos/" + videoToBeUpdated.videoId,
        )
        .then((response) => {
          console_log(response);
        })
        .catch((error) => {
          console_log(error);
        });
    }

    this.props.addFavoriteVideo(favoriteVideos);
  }

  isChannelFavorite(channelId) {
    let indexOf = this.props.favorite.channels.findIndex((f) => {
      return f.channelId == channelId;
    });

    if (indexOf != -1) {
      return true;
    }
    return false;
  }

  isVideoFavorite(videoId) {
    let indexOf = this.props.favorite.videos.findIndex((f) => {
      return f.videoId == videoId;
    });

    if (indexOf != -1) {
      return true;
    }
    return false;
  }

  goToPlayOthers(data, event) {
    event.preventDefault();
    if (
      event.target.tagName == "path" ||
      event.target.classList.contains("favoriteClick")
    ) {
      this.videoFavorite(data.video);
    } else {
      this.props.getVideoOrChannelRelatedData(data);
      this.props.history.push(`/show?uid=${this.props.access.uid}`);
    }
  }
  setfavoriteVideos() {
    let uid = this.props.access.uid;
    const heartIcon =
        '<svg class="favoriteClick" xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewbox="0 0 70 70" preserveAspectRatio="none"><path d="M66.43 20.39c-.93-10.37-8.21-17.9-17.32-17.9a17.224 17.224 0 0 0-14.76 8.57 16.588 16.588 0 0 0-14.4-8.57c-9.11 0-16.39 7.52-17.33 17.9a18.807 18.807 0 0 0 .55 6.8 29.14 29.14 0 0 0 8.86 14.91l22.31 20.41L57.02 42.1a29.227 29.227 0 0 0 8.87-14.91 18.412 18.412 0 0 0 .54-6.8z" data-name="fave ico" class="heart-fill"/></svg>',
      playIcon =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path fill="#fff" d="M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>';

    let mixContent = bidiotvMoviesListByLang.concat(this.props.category.videos);
    let favoriteChannelIds = this.props.favorite.channels.map(
      (c) => c.channelId,
    );
    let favoriteChannels = this.props.category.channels.filter((channel) => {
      if (~favoriteChannelIds.indexOf(channel.channelId)) {
        return channel;
      }
    });
    let favorite;
    let langauge;
    let category;
    let favoriteVideoIds = this.props.favorite.videos.map((v) => v.videoId);
    let favoriteVideos = [].concat
      .apply(
        [],
        this.props.category.videos.map((c) => c.videos),
      )
      .filter((v) => {
        if (~favoriteVideoIds.indexOf(v.id)) {
          return v;
        }
      });

    let watchfavorite = [].concat
      .apply(
        [],
        mixContent.map((c) => c.videos),
      )
      .filter((v) => {
        if (~favoriteVideoIds.indexOf(v.id)) {
          return v;
        }
      });
    let bidiotvfavorite = [].concat
      .apply(
        [],
        bidiotvMoviesListByLang.map((c) => c.videos),
      )
      .filter((v) => {
        if (~favoriteVideoIds.indexOf(v.id)) {
          return v;
        }
      });

    let esdomainfavorite = [].concat
      .apply(
        [],
        esmobiotv.map((c) => c.videos),
      )
      .filter((v) => {
        if (~favoriteVideoIds.indexOf(v.id)) {
          return v;
        }
      });
    let favoriteRecentlyAdded = [].concat
      .apply(
        [],
        movies.map((c) => c.videos),
      )
      .filter((v) => {
        if (~favoriteVideoIds.indexOf(v.id)) {
          return v;
        }
      });

    if (config.title == "watch") {
      favoriteVideos = watchfavorite;
      langauge = English;
    } else if (config.title == "es") {
      langauge = spanish;
      favorite = esdomainfavorite;
      favorite.map((f) => {
        let videoCategory = esmobiotv.find((category) => {
          let videoIds = category.videos.map((v) => v.id);
          if (~videoIds.indexOf(f.id)) {
            return category;
          }
        });

        return (f.videocat = videoCategory.name);
      });
    } else {
      favorite = bidiotvfavorite;
      langauge = English;
    }
    if (config.title == "bidiotv") {
      return (
        <div className="bidiotv-watch-later">
          <Row>
            <Col sm="12">
              {favorite.length > 0 ? (
                <div className="grid-list-row favorites-row">
                  {favorite.map((video) => {
                    return (
                      <div
                        key={video.id}
                        className="grid-list-col favorites-col"
                      >
                        <div
                          className="list-view"
                          onClick={
                            config.title == "es"
                              ? this.goToPlayOthers.bind(this, { video: video })
                              : this.goToPlay.bind(this, { video: video })
                          }
                        >
                          <div className="channels-thumb channels-thumb--genre">
                            <div className="channels-image channels-image--genre no-radius">
                              <img
                                className="channels-thumb__image channels-thumb__image--genre rounded-0 no-radius"
                                src={video.preview}
                                alt={video.name}
                              />
                            </div>
                          </div>
                          <div className="channels-thumb__details">
                            <div className="channels-thumb__fav">
                              <input
                                className="icon-toggle favoriteClick"
                                id={"vod" + video.id}
                                type="checkbox"
                                checked={this.isVideoFavorite(video.id)}
                                onChange={() => {}}
                              />
                              <label
                                className="icon-toggle-label favoriteClick"
                                htmlFor={"vod" + video.id}
                              >
                                <span className="favoriteClick">
                                  <i
                                    className="fa fa-star favoriteClick"
                                    aria-hidden="true"
                                  ></i>
                                </span>
                              </label>
                            </div>
                            <div className="channels-thumb__inner">
                              <div className="channels-thumb__name">
                                <FormattedMessage
                                  id={video.name}
                                  defaultMessage={video.name}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="no-favorites__pane no-favorites__pane--videos-only">
                  <h4 className="favorites__pane__title">
                    <FormattedMessage
                      id="noVids"
                      defaultMessage="No Videos Added To Favorites Yet"
                    />
                  </h4>
                  <p className="favorites__pane__text">
                    <FormattedMessage
                      id="addYour"
                      defaultMessage="Add your favorite videos to access and watch easily without any hassles."
                    />
                  </p>
                </div>
              )}
              <div className="text-center">
                <a
                  className="common-btn common-btn--brown common-btn--fav"
                  href={`/#/home?uid=${uid}`}
                >
                  <span className="common-btn__text">
                    <FormattedMessage
                      id="exploreVids"
                      defaultMessage="Explore Videos"
                    />
                  </span>
                </a>
              </div>
            </Col>
          </Row>
        </div>
      );
    } else if (config.title == "es") {
      return (
        <div className="bidiotv-watch-later">
          <Row>
            <Col sm="12">
              {favorite.length > 0 ? (
                <div className="grid-list-row show-list favorites-row">
                  {favorite.map((m) => {
                    return (
                      <div
                        key={m.id}
                        className="shows portrait__slide portrait__slide--mobile hover__data"
                        onClick={this.goToPlayOthers.bind(this, { video: m })}
                      >
                        <div className="portrait__image portrait__image--mobile">
                          <img
                            className="shows__thumb"
                            src={m.preview}
                            alt={m.name}
                          />
                        </div>
                        <div className="portrait__details portrait__details--mobile">
                          <div className="channels-thumb__fav">
                            <input
                              className="icon-toggle favoriteClick"
                              id={m.id}
                              type="checkbox"
                              checked={this.isVideoFavorite(m.id)}
                              onChange={() => {}}
                            />
                            <label
                              className="icon-toggle-label favoriteClick"
                              htmlFor={m.id}
                            >
                              <span className="favoriteClick">
                                <i
                                  className="fa fa-star favoriteClick"
                                  aria-hidden="true"
                                ></i>
                              </span>
                            </label>
                          </div>
                          <div className="hover__details">
                            <div className="hover__container">
                              <div className="hover__title-wrap">
                                <h3 className="hover__title">{m.name}</h3>
                              </div>
                              <ul className="list-unstyled">
                                {/* <li><span>{m.category.name}</span></li> */}
                                <li>
                                  <span>PG,</span>
                                  <span>1hr 38min</span>
                                </li>
                                {config.title == "es" ? (
                                  <li>
                                    <span>{m.likes + " likes"}</span>
                                    <span className="hover__details__views">
                                      {m.views + " views"}
                                    </span>
                                  </li>
                                ) : (
                                  ""
                                )}
                              </ul>
                              <span
                                className="hollow-arrow"
                                dangerouslySetInnerHTML={{ __html: playIcon }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="no-favorites__pane no-favorites__pane--videos-only">
                  <h4 className="favorites__pane__title">
                    <FormattedMessage
                      id="noVids"
                      defaultMessage="No Videos Added To Favorites Yet"
                    />
                  </h4>
                  <p className="favorites__pane__text">
                    <FormattedMessage
                      id="addYour"
                      defaultMessage="Add your favorite videos to access and watch easily without any hassles."
                    />
                  </p>
                </div>
              )}
              <div className="text-center">
                <a
                  className="common-btn common-btn--pink common-btn--fav"
                  href={`/#/home?uid=${this.props.access.uid}`}
                >
                  <span className="common-btn__text">
                    <FormattedMessage
                      id="exploreVids"
                      defaultMessage="Explore Videos"
                    />
                  </span>
                </a>
              </div>
            </Col>
          </Row>
        </div>
      );
    } else {
      return (
        <div>
          <Nav pills className="favorites__tabs">
            {/* <NavItem className="favorites__vod">
                            <NavLink className={classnames({ active: this.state.activeTab === '1' })} onClick={() => { this.toggle('1'); }}>
                                <FormattedMessage id="vod"
                                    defaultMessage="Videos on Demand"
                                />
                            </NavLink>
                        </NavItem> */}
            {/* <NavItem className="favorites__live">
                            <NavLink className={classnames({ active: this.state.activeTab === '2' })} onClick={() => { this.toggle('2'); }}>
                                <FormattedMessage id="liveChannels"
                                    defaultMessage="Live Channels"
                                />
                            </NavLink>
                        </NavItem> */}
          </Nav>
          <TabContent
            className="favorites__content"
            activeTab={this.state.activeTab}
          >
            <TabPane tabId="1">
              <Row>
                <Col xs="12">
                  {favoriteVideos.length > 0 ||
                  favoriteRecentlyAdded.length > 0 ? (
                    <div>
                      <div className="grid-list-row favorites-row">
                        {favoriteVideos.map((video) => {
                          return (
                            <div
                              key={video.id}
                              className="grid-list-col favorites-col"
                            >
                              <div
                                className="list-view"
                                onClick={this.goToPlay.bind(this, {
                                  video: video,
                                })}
                              >
                                <div className="channels-thumb channels-thumb--genre">
                                  <div className="channels-image channels-image--genre no-radius">
                                    <img
                                      className="channels-thumb__image channels-thumb__image--genre rounded-0 no-radius"
                                      src={video.preview}
                                      alt={video.name}
                                    />
                                  </div>
                                </div>
                                <div className="channels-thumb__details">
                                  <div className="channels-thumb__fav">
                                    <input
                                      className="icon-toggle favoriteClick"
                                      id={"vod" + video.id}
                                      type="checkbox"
                                      checked={this.isVideoFavorite(video.id)}
                                      onChange={() => {}}
                                    />
                                    <label
                                      className="icon-toggle-label favoriteClick"
                                      htmlFor={"vod" + video.id}
                                    >
                                      <span className="favoriteClick">
                                        <i
                                          className="fa fa-star favoriteClick"
                                          aria-hidden="true"
                                        ></i>
                                      </span>
                                    </label>
                                  </div>
                                  <div className="channels-thumb__inner">
                                    <div className="channels-thumb__name">
                                      {video.name}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <div className="shows__wrap favorites-row">
                        {favoriteRecentlyAdded.map((m) => {
                          return (
                            <div
                              key={m.id}
                              className="shows portrait__slide portrait__slide--mobile hover__data"
                              onClick={this.goToPlayOthers.bind(this, {
                                video: m,
                              })}
                            >
                              <div className="portrait__image portrait__image--mobile">
                                <img
                                  className="shows__thumb"
                                  src={m.preview}
                                  alt={m.name}
                                />
                              </div>
                              <div className="portrait__details portrait__details--mobile">
                                <div className="channels-thumb__fav">
                                  <input
                                    className="icon-toggle favoriteClick"
                                    id={m.id}
                                    type="checkbox"
                                    checked={this.isVideoFavorite(m.id)}
                                    onChange={() => {}}
                                  />
                                  <label
                                    className="icon-toggle-label favoriteClick"
                                    htmlFor={m.id}
                                  >
                                    <span className="favoriteClick">
                                      <i
                                        className="fa fa-star favoriteClick"
                                        aria-hidden="true"
                                      ></i>
                                    </span>
                                  </label>
                                </div>
                                <div className="hover__details">
                                  <div className="hover__container">
                                    <div className="hover__title-wrap">
                                      <h3 className="hover__title">{m.name}</h3>
                                    </div>
                                    <ul className="list-unstyled">
                                      {/* <li><span>{video.category.name}</span></li> */}
                                      <li>
                                        <span>PG,</span>
                                        <span>1hr 38min</span>
                                      </li>
                                      {config.title == "es" ? (
                                        <li>
                                          <span>{m.likes + " likes"}</span>
                                          <span className="hover__details__views">
                                            {m.views + " views"}
                                          </span>
                                        </li>
                                      ) : (
                                        ""
                                      )}
                                    </ul>
                                    <span
                                      className="hollow-arrow"
                                      dangerouslySetInnerHTML={{
                                        __html: playIcon,
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ) : (
                    <div className="no-favorites__pane">
                      <h4 className="favorites__pane__title">
                        <FormattedMessage
                          id="noVideos"
                          defaultMessage="No Videos Added To Watch Later Yet"
                        />
                      </h4>
                      <p className="favorites__pane__text">
                        <FormattedMessage
                          id="addYour"
                          defaultMessage="Add your favorite videos to access and watch easily without any hassles."
                        />
                      </p>
                    </div>
                  )}

                  <div className="text-center">
                    <a
                      className="common-btn common-btn--pink common-btn--fav"
                      href={`/#/home?uid=${uid}`}
                    >
                      <span className="common-btn__text">
                        <FormattedMessage
                          id="exploreVids"
                          defaultMessage="Explore Videos"
                        />
                      </span>
                    </a>
                  </div>
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </div>
      );
    }
  }
  render() {
    return (
      <section className="favorites py-0">{this.setfavoriteVideos()}</section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    access: state.WelcomeReducer,
    account: state.AccountReducer,
    category: state.CategoryReducer,
    country: state.CountryReducer,
    domain: state.DomainReducer,
    favorite: state.FavoriteReducer,
    flashmessage: state.FlashMessageReducer,
    historyVideos: state.HistoryReducer,
    loader: state.ActivityIndicatorReducer,
    play: state.PlayReducer,
    smartTV: state.SmartTVReducer,
    splash: state.SplashScreenReducer,
    user: state.AuthenticationReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      show,
      hide,
      getVideoOrChannelRelatedData,
      addFavoriteChannel,
      addFavoriteVideo,
      showMessage,
      setHeaderTitle,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Favorites);



// WEBPACK FOOTER //
// ./src/components/Favorites/Favorites.js